module.exports = __webpack_public_path__ + "img/image_middle_empty_check_d@2x.9e2b5aff.png";